import axiosInstance from "../instance/axiosInstance";

class UsersApi {
  static async usersList(page, searchQuery) {
    let url = `/organization/user/list?page=${page}`;

    if (searchQuery) {
      url += `&search_value=${encodeURIComponent(searchQuery)}`;
    }

    try {
      const response = await axiosInstance.get(url);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }

  static async deleteUser(id) {
    try {
      const response = await axiosInstance.get(
        `/organization/user/delete/${id}`
      );
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }

  static async createUser(formData, signal) {
    try {
      const response = await axiosInstance.post(
        "/organization/user/save",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          signal,
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  static async checkUserLimit() {
    try {
      const response = await axiosInstance.get(
        "/organization/user/limit-check"
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  static async getEditUserInfo(userId) {
    try {
      const response = await axiosInstance.get(
        `/organization/user/edit/${userId}`
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }

  static async getUserInfo(userId) {
    try {
      const response = await axiosInstance.get(
        `/organization/user/view/${userId}`
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }

  static async changeUserStatus(formData) {
    try {
      const response = await axiosInstance.put(
        `/organization/user/status-update`,
        formData
      );
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
}

export default UsersApi;
